<template>
  <div class="c-agenda">

    <!--
        <img src="../../assets/images/beauty4.png" class="beauty4" alt="">
        <img src="../../assets/images/beauty2.png" class="beauty2" alt="">
        <img src="../../assets/images/beauty3.png" class="beauty3" alt="">-->
    <div class="agenda-list">
      <div v-for="(item,index) in scheduleList" :key="item.agendaId" class="agenda-list-group">
        <div class="agenda-group-name " :class="{'no-top':index!=0}">{{ item.name }}</div>
        <div v-if="item.item.length>0">
        <div class="agenda-item" v-for="list in item.item" :key="list.agendaId">
            <div class="left-content">
              <div class="title">{{ list.theme.replace('|&|', '') }}</div>
              <div class="date">{{ list.startTimeDate }}-{{ list.endTimeDate }}</div>
            </div>
            <div class="right-content" v-show="list.agendaGuest && list.agendaGuest.length>0"
                 v-for="(guest, i) in list.agendaGuest" :key="i">
              <div class="head">
                <div class="head-img">
                  <img class="head-img2" :src="guest.head" alt="">
                </div>
              </div>
              <div class="content">

                <div class="name-position">
                  <div class="name">{{ guest.name }}</div>
                  <div class="position" v-if="guest.enterprise">{{ guest.enterprise }}</div>
                </div>

              </div>
            </div>
        </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {$subscriber, cr, URLS} from "fire-wind-water";
import {validateState} from "@/common/joinMeeting";
import moment from "moment";

export default {
  name: "Schedule",
  data() {
    return {
      // scheduleList: [],
      originScheduleList:[],
      amList: [],
      pmList: [],
      replaySwitch: 0,
      userInfo: {},
      webinarInfo: {}
    };
  },
  computed: {
    scheduleList() {
      let newAgendaList = [];
      for (let i in window.agendaGroup) {
        console.log(i)    //输出 ： a   b  c
        newAgendaList.push({
          agendaId: Math.random(),
          name: i,
          item: this.getAgendaGroup(this.originScheduleList, window.agendaGroup[i])
        })
      }
      return  newAgendaList;
    }
  },
  created() {
    this.init();
  },
  methods: {
    getUrlParam(sUrl, sKey) {
      // 返回?后面#前面的
      let sParam = sUrl.split("?")[1].split("#")[0];  // key=1&key=2&key=3&test=4
      // 进一步将参数分割为数组
      let arr = sParam.split("&"); // ["key=1","key=2","key=3","test=4"]
      // 结果
      let res;
      if (sKey) { // 如果指定参数
        // 结果为数组
        res = [];
        for (let i = 0; i < arr.length; i++) {
          // 分割为键值对
          let temp = arr[i].split("=");
          // 存储指定key值的结果
          if (temp[0] === sKey) {
            res.push(temp[1]);
          }
        }
        if (res.length === 1) {
          // 长度为1，返回字符串
          return res[0];
        } else if (res.length === 0) {
          // 长度为0，返回空字符串
          return "";
        } else {
          // 长度大于1返回数组
          return res;
        }

      } else { // 如果不指定参数
        // 结果为对象
        res = {};
        if (sParam === undefined || sParam === "") {
          return res;
        }
        for (let i = 0; i < arr.length; i++) {
          // 分割为键值对
          let temp = arr[i].split("=");
          // 判断是否已存在结果
          if (!(temp[0] in res)) {
            // temp[0]为键，temp[1]的数组为值
            res[temp[0]] = [];
          }
          // 使用变量动态访问对象属性用obj[a]不能用obj.a
          res[temp[0]].push(temp[1]);
        }

      }
      return res;
    },
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        //把嘉宾的数据 和日常的数据组合一下
        this.webinarInfo = data;
        this.replaySwitch = data.replaySwitch;
        cr.each(data.agendaList, d => {
          d.endTimeDate = moment(d.endTime * 1000).format("HH:mm");
          d.startTimeDate = moment(d.startTime * 1000).format("HH:mm");
          cr.each(d.agendaGuest, n => {
            cr.each(data.guestList, list => {
              if (list.webinarGuestId == n.webinarGuestId) {
                n.duty = list.duty; //"这是职务"
                n.enterprise = list.enterprise; //"这是公司"
                n.department = list.department; //"这是部门"
                n.head = list.realPath;
              }
            });
          });
        });
//        let nuanchangNum = 0;
       cr.each({...data.agendaList}, d => {
         d.theme=d.theme.replaceAll('^|^','')

       })
        console.log('data.agendaList', data.agendaList)
        this.originScheduleList = data.agendaList;

      });
      $subscriber.subscribe("userInfo", data => {
        this.userInfo = data;
        console.log("userInfo", this.userInfo);
      });
    },
    async joinBtnClick(type) {
      let info = window.$sk.webinar.get().meetingInfo;
      //处理goToSignUpUrl
      if (info.goToSignUpUrl) {
        let back = decodeURIComponent(this.getUrlParam(info.goToSignUpUrl, 'returnUrl'));
        let url = encodeURIComponent(URLS.updateSearchParam('type', type, back));
        let url2 = URLS.updateSearchParam('returnUrl', url, info.goToSignUpUrl);
        info.goToSignUpUrl = url2;
      }
      //////


      let webinarInfo = Object.assign(this.webinarInfo, info);
      let userInfo = Object.assign(
          this.userInfo,
          window.$sk.webinar.get().user
      );
      //验证用户状态  审核中 未通过 无权限  会议已经关闭 会场未发布
      if (window.$sk.webinar.get().canJoin(webinarInfo, userInfo)) {
        if (window.$sk.webinar.get().canEnter(webinarInfo, userInfo)) {
          //可进入会场
          window.location.href = URLS.updateSearchParam('type', type, window.location.href.replace(
              "/meetingInfo",
              "/meeting"
          ));
        } else {
          let returnUrl = window.location.href;
          if (!webinarInfo.isClosed) {
            returnUrl = URLS.updateSearchParam('type', type, window.location.href.replace(
                "/meetingInfo",
                "/meeting"
            ));
          }
          if (
              !webinarInfo.isClosed &&
              !webinarInfo.unLimit &&
              webinarInfo.needLogin &&
              !userInfo.isLogin &&
              !webinarInfo.isClosed &&
              !webinarInfo.unLimit &&
              webinarInfo.needRegistration &&
              !userInfo.isRegistration
          ) {
            window.$sk.goto(
                webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(webinarInfo.goToSignUpUrl)
            );
          } else if (
              !webinarInfo.isClosed &&
              !webinarInfo.unLimit &&
              webinarInfo.needLogin &&
              !userInfo.isLogin
          ) {
            window.$sk.goto(
                webinarInfo.loginUrl +
                "sourceKey=" +
                URLS.getURL("sourceKey") +
                "&backUrl=" +
                encodeURIComponent(returnUrl)
            );
          } else if (
              !webinarInfo.isClosed &&
              !webinarInfo.unLimit &&
              webinarInfo.needRegistration &&
              !userInfo.isRegistration
          ) {

            window.$sk.goto(webinarInfo.goToSignUpUrl);
          } else {
            window.$sk.goto(returnUrl);
          }
        }
      } else {
        if (this.webinarInfo.isOnDemand) {
          window.location.href = webinarInfo.demandUrl;
        } else {
          validateState(webinarInfo, this.userInfo);
        }
      }
    },
    getAgendaGroup(data, arr) {
      let newArry = []
      arr.forEach((item) => {
        data[item] && newArry.push(data[item])
      });
      return newArry
    }
  }
};
</script>

<style scoped></style>
